var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCoursesTotal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 78,
    viewBox: "0 0 79 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.9835 39.7296C65.7552 26.378 63.8645 -2.68016 39.5976 0.199308C15.3306 3.07877 -0.0020954 36.3266 1.00047 47.8454C2.00303 59.3642 9.52091 80.8311 44.1093 77.6896C78.6976 74.5481 84.2117 53.0812 74.9835 39.7296Z",
    fill: "url(#paint0_linear_46_512)",
    fillOpacity: 0.36
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_46_512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.7219 32.2954L30.2972 29.3462C30.2972 32.0389 30.2744 32.0198 30.3591 32.2739C30.4758 32.6386 30.7524 32.9415 31.1233 33.0836C40.3028 36.6146 39.6574 36.4059 40.0001 36.4059C40.3399 36.4059 39.6865 36.6185 48.8761 33.0836C49.3685 32.8944 49.703 32.4218 49.703 31.8802V29.4872L41.2233 32.3143C40.4097 32.5855 39.5298 32.5787 38.7219 32.2954Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3106 25.166C26.6209 25.3716 25.583 24.9644 39.5739 29.861C39.8425 29.9561 40.1345 29.9583 40.4077 29.8679C45.2818 28.243 48.3961 27.2048 52.3025 25.9027V33.1747C52.3025 33.5306 52.4469 33.8538 52.6807 34.0867C53.4886 34.8947 54.8812 34.3195 54.8812 33.1747C54.8812 24.3832 54.8789 24.1844 54.8786 24.1855C54.9174 23.6356 54.5709 23.0813 53.9993 22.8907C40.2343 18.3027 40.3058 18.2946 40.0002 18.2946C39.6831 18.2946 39.7753 18.2972 26.6304 22.8967C25.6498 23.2399 25.4552 24.5543 26.3106 25.166Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7559 45.4623H28.3552V48.0608H25.7559V45.4623Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7106 24.1139H57.4597V33.1747C57.4597 35.3082 55.7242 37.0428 53.5916 37.0428C52.2189 37.0428 51.0112 36.3242 50.3244 35.2437C49.9692 35.4451 50.5591 35.1994 41.3891 38.7267C40.5106 39.0648 39.5216 39.0766 38.6109 38.7267L30.1974 35.4904C28.7034 34.9152 27.7184 33.4822 27.7184 31.8802V28.4444L25.7783 27.7645C24.2285 27.223 23.1875 25.7557 23.1875 24.1139H19.2894C18.5776 24.1139 18 24.6915 18 25.4033V53.2389C18 53.9507 18.5776 54.5283 19.2894 54.5283H30.9441V57.1268H27.0556C26.3439 57.1268 25.7663 57.7044 25.7663 58.4162C25.7663 59.1287 26.3439 59.7055 27.0556 59.7055H52.9444C53.6561 59.7055 54.2337 59.1287 54.2337 58.4162C54.2337 57.7044 53.6561 57.1268 52.9444 57.1268H49.0558V54.5283H60.7106C61.4224 54.5283 62 53.9507 62 53.2389V25.4033C62 24.6915 61.4224 24.1139 60.7106 24.1139ZM30.934 49.3502C30.934 50.0628 30.3564 50.6396 29.6447 50.6396H24.4666C23.7549 50.6396 23.1772 50.0628 23.1772 49.3502V44.173C23.1772 43.4604 23.7549 42.8836 24.4666 42.8836H29.6447C30.3564 42.8836 30.934 43.4604 30.934 44.173V49.3502ZM55.5334 50.6396H34.8219C34.1102 50.6396 33.5325 50.0628 33.5325 49.3502C33.5325 48.6385 34.1102 48.0608 34.8219 48.0608H55.5334C56.2451 48.0608 56.8228 48.6385 56.8228 49.3502C56.8228 50.0628 56.2451 50.6396 55.5334 50.6396ZM55.5334 45.4623H34.8219C34.1102 45.4623 33.5325 44.8847 33.5325 44.173C33.5325 43.4604 34.1102 42.8836 34.8219 42.8836H55.5334C56.2451 42.8836 56.8228 43.4604 56.8228 44.173C56.8228 44.8847 56.2451 45.4623 55.5334 45.4623Z",
    fill: "#821C6B",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_46_512",
    x1: -5.23708,
    y1: 9.63185,
    x2: 81.4697,
    y2: 50.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#821C6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#821C6B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_46_512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(18 17)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCoursesTotal);
export default __webpack_public_path__ + "static/media/ic-courses-total.c944e7a6626344f1934baaab34fda312.svg";
export { ForwardRef as ReactComponent };